import React from "react";
import { withRouter, Switch, Route } from "react-router-dom";

import { OriginThemeProvider } from "@origin-digital/ods-core";
import { SharedAppProvider } from "@origin-digital/shared-app-context";

import { routes } from "./consts";

import { ErrorWrapper } from "./components/ErrorWrapper";

import { CustomerRedirect } from "./pages/CustomerRedirect";
import { MyAccountSetup } from "./pages/MyAccountSetup";
import { Spike } from "./pages/Spike";
import { UnderConstruction } from "./pages/UnderConstruction";

declare const __DEV__: boolean;

const componentWithContext = (Component: React.FC) => () => (
  <SharedAppProvider xhrInitialize={__DEV__}>
    <Component />
  </SharedAppProvider>
);

export const Root = withRouter(() => (
  <OriginThemeProvider>
    <ErrorWrapper>
      <Switch>
        <Route
          path={routes.customerRedirect}
          component={componentWithContext(CustomerRedirect)}
        />
        <Route path={routes.myAccountSetup} component={MyAccountSetup} />
        <Route path={routes.spike} component={Spike} />
        <Route path={routes.underConstruction} component={UnderConstruction} />
      </Switch>
    </ErrorWrapper>
  </OriginThemeProvider>
));
